import React from "react"
import PropTypes from "prop-types"
import Lien from "../navigation/Lien"

import { locales } from "../../../locales"

export default function BlocIcones({ langue }) {
  return (
    <div className="boutique-icones-conteneur">
      <div className="boutique-icones-conteneur-icone-et-texte">
        <div className="boutique-icones-conteneur-icone">
          {iconeLivraison()}
        </div>
        <div className="boutique-icones-conteneur-texte">
          {locales[langue].boutique.informationsLivraison}
        </div>
      </div>
      <div className="boutique-icones-conteneur-icone-et-texte">
        <div className="boutique-icones-conteneur-icone">
          {iconePaiementSecurise()}
        </div>
        <div className="boutique-icones-conteneur-texte">
          {locales[langue].boutique.paiementSecurise}
        </div>
      </div>
      <div className="boutique-icones-conteneur-icone-et-texte">
        <div className="boutique-icones-conteneur-icone">
          {iconeTelephone()}
        </div>
        <div className="boutique-icones-conteneur-texte">
          {locales[langue].boutique.besoinDAide} {lienContactezMoi(langue)}
        </div>
      </div>
    </div>
  )
}

function iconeLivraison() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
    </svg>
  )
}

function iconePaiementSecurise() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
    </svg>
  )
}

function iconeTelephone() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
    </svg>
  )
}

function lienContactezMoi(langue) {
  return (
    <Lien codePageCible={locales[langue].boutique.pageContact}>
      {locales[langue].site.contact}
    </Lien>
  )
}

BlocIcones.propTypes = {
  texte: PropTypes.string,
  langue: PropTypes.string,
}
